module.exports = __webpack_public_path__ + "static/media/binance.62f166b6.png";